<script>
import ReportMixin from '@/mixins/report'

export default {
  name: 'Dashboard',
  mixins: [ReportMixin],
  data() {
    return {
      dashboardDescription: '',
      dashboardConfig: {},
      formKey: 0,
      reportData: {},
      reportParameters: {},
      dashboardRan: false,
      dashboardPublic: false,
      reportDetails: {}
    }
  },
  watch: {
    name: function() {
      this.loadDashboardDetails()
    }
  },
  computed: {
    allFormData() {
      return {
        ...(this.reportParameters ||
          this.$refs['graphql-form'].$refs.form.formData)
      }
    },
    reportNames() {
      return this.dashboardConfig
        .map(tile => tile.report)
        .filter((value, index, self) => self.indexOf(value) === index)
    },
    dashboardTiles() {
      return this.dashboardConfig
        .map(tile => {
          return tile.tile
            ? {
                ...this.reportDetails[tile.report].reportFields.find(
                  field =>
                    tile.tile ==
                    (field.key || field.field || field.name || field)
                ),
                ...tile
              }
            : tile
        })
        .map(tile => {
          tile.label = this.getLabel(tile)
          if (tile.label == '') {
            if (tile.tile) {
              tile.field = tile.tile
              delete tile.label
              tile.label = this.getLabel(tile)
            } else {
              tile.label = tile.report
            }
          }
          tile.reportFields = this.getReportFields(
            this.reportDetails[tile.report]
          ).filter(field => (tile.tile ? tile.tile == field.key : true))
          return tile
        })
    },
    dashboardOnly() {
      return this.$route.meta.dashboardOnly
    }
  },
  methods: {
    loadDashboardDetails(fromLoad) {
      this.reportRan = false
      this.graphql(
        /* GraphQL */ `
          query lookupOptions_DashboardLookup($dashboardName: String!) {
            allMetricsDashBoards(condition: { dashboardName: $dashboardName }) {
              nodes {
                dashboardName
                dashboardDesc
                dashboardConfig
                dashboardPermissions
              }
            }
          }
        `,
        { dashboardName: this.name }
      ).then(data => {
        this.dashboardRan = false
        this.dashboardConfig = null
        if (data.allMetricsDashBoards.nodes.length) {
          this.dashboardDescription =
            data.allMetricsDashBoards.nodes[0].dashboardDesc
          this.dashboardConfig =
            data.allMetricsDashBoards.nodes[0].dashboardConfig
          this.dashboardPublic =
            data.allMetricsDashBoards.nodes[0].dashboardPermissions &&
            data.allMetricsDashBoards.nodes[0].dashboardPermissions.public
          this.reportDetails = {}
          this.reportNames.forEach(reportName => {
            this.reportDetails[reportName] = {
              detailsLoaded: false
            }
            this.loadReportDetails(reportName).then(reportDetailsData => {
              this.reportDetails[reportName] =
                reportDetailsData.allMetricsDashReports.nodes[0].reportDetails
              this.reportDetails[reportName].detailsLoaded = true
              if (
                !Object.values(this.reportDetails).filter(
                  report => !report.detailsLoaded
                ).length
              ) {
                this.formTypes.CURRENT_DASHBOARD.form.schema = []
                Object.values(this.reportDetails).forEach(report => {
                  this.formTypes.CURRENT_DASHBOARD.form.schema = this.formTypes.CURRENT_DASHBOARD.form.schema.concat(
                    (report.formSchema || []).filter(field => {
                      return (
                        Array.isArray(field) ||
                        this.flattenFields(
                          this.formTypes.CURRENT_DASHBOARD.form.schema
                        ).indexOf(field.field || field) == -1
                      )
                    })
                  )
                })
                this.formKey++
                if (fromLoad) {
                  if (this.$route.query.filters) {
                    let setFormData = () => {
                      if (
                        this.$refs['graphql-form'].$refs.form.optionsLoaded ==
                        false
                      ) {
                        setTimeout(setFormData, 250)
                        return
                      }
                      this.$set(
                        this.$refs['graphql-form'].$refs.form,
                        'formData',
                        JSON.parse(this.$route.query.filters)
                      )
                    }
                    setTimeout(setFormData, 250)
                    this.formSubmit(JSON.parse(this.$route.query.filters))
                  } else {
                    setTimeout(() => {
                      this.$refs['graphql-form'].$refs.form.submitForm()
                    }, 100)
                  }
                } else {
                  setTimeout(() => {
                    this.$refs['graphql-form'].$refs.form.submitForm()
                  }, 100)
                }
              }
            })
          })
        }
      })
    },
    formSubmit(submitData) {
      this.reportParameters = submitData
      this.dashboardRan = false
      this.resultsCurrentPage = 1
      this.reportData = {}
      this.reportNames.forEach(reportName => {
        this.graphql(
          this.buildReportQuery(this.reportDetails[reportName]),
          submitData
        ).then(data => {
          if (Object.keys(data).length == 1) {
            if (Object.keys(data[Object.keys(data)[0]]).length == 1) {
              this.reportData[reportName] =
                data[Object.keys(data)[0]][
                  Object.keys(data[Object.keys(data)[0]])[0]
                ]
              if (
                Object.keys(this.reportData).length == this.reportNames.length
              ) {
                this.dashboardRan = true
                // This is to clear the loading screen if running with parameters (direct link) and not all the select options have come back
                if (window.formActionPopups.showLoading) {
                  window.formActionPopups.showLoading = 0
                }
              }
            }
          }
        })
      })
    },
    publicLinkToClipboard() {
      navigator.clipboard.writeText(
        `${window.location.origin}/metrics/public-dashboard/${this.name}`
      )
    }
  },
  mounted() {
    this.loadDashboardDetails(true)
  }
}
</script>

<template>
  <div :class="{ dashboardOnly }">
    <h1 v-if="dashboardConfig == null">Dashboard Not Found: {{ name }}</h1>
    <Container v-else :expanded="!dashboardRan">
      <template v-slot:header>Dashboard Details: {{ name }}</template>
      <template v-slot:content>
        <p
          class="m-2 text-center"
          v-html="dashboardDescription"
          v-if="dashboardDescription"
        ></p>
        <hr v-if="dashboardDescription" />
        <GraphQLFormEdit
          formType="CURRENT_DASHBOARD"
          :submitTriggerInsteadOfSave="true"
          @submitForm="formSubmit"
          :key="formKey"
          v-if="formKey"
          ref="graphql-form"
          :showResetButton="formTypes.CURRENT_DASHBOARD.form.schema.length > 0"
        />
        <div class="text-center mt-3" v-if="dashboardPublic">
          <b-button
            class="button"
            id="copyClipboardButtion"
            @click="publicLinkToClipboard"
            >Copy Public URL</b-button
          >
          <b-popover target="copyClipboardButtion" triggers="click blur">
            Link Copied
          </b-popover>
        </div>
      </template>
    </Container>
    <Container v-if="dashboardRan">
      <template v-slot:header>Dashboard</template>
      <template v-slot:content>
        <b-row>
          <template v-for="(tile, tileIndex) in dashboardTiles">
            <b-col :key="tileIndex" :cols="tile.width">
              <Container class="dashboard-tile" :collapsable="false">
                <template v-slot:header>{{ tile.label }}</template>
                <template v-slot:content>
                  <slot name="content">
                    <ReportResults
                      :reportName="tile.report"
                      :reportRecords="reportData[tile.report]"
                      :reportParameters="reportParameters"
                      :reportFields="tile.reportFields"
                      :chartTypes="[tile.chartType]"
                      :chartType="tile.chartType"
                      :reportDetails="reportDetails[tile.report]"
                      :inTile="true"
                    />
                  </slot>
                </template>
              </Container>
            </b-col>
          </template>
        </b-row>
      </template>
    </Container>
  </div>
</template>

<style>
.dashboardOnly > .detailsContainer,
.dashboard-tile .report-container,
.dashboard-tile .report-container > .containerContent .tile-container {
  margin: 0px;
  padding: 0px;
  border: 0px solid black;
}
.dashboardOnly > .detailsContainer > .containerHeader,
.dashboard-tile .report-container > .containerHeader,
.dashboard-tile
  .report-container
  > .containerContent
  .tile-container
  > .containerHeader {
  display: none;
}
.dashboard-tile .report-container > .containerContent .row,
.dashboard-tile .report-container > .containerContent .row .col-12 {
  padding: 0px;
  margin: 0px;
}
</style>
